import React, { useEffect } from 'react';
import { 
  Container, Box, Typography, Grid, 
  Card, CardContent, Button, CardActions // Import CardActions
} from '@mui/material';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'; // Optional: Game Icon

const gameList = [
  {
    title: "PBS Kids Holiday Games",
    description: "Play fun holiday-themed games with your favorite characters.",
    linkUrl: 'https://pbskids.org/games/winter' 
  },
  {
    title: "Santa's North Pole Games",
    description: "How good are you at stacking presents or sorting letters?",
    linkUrl: 'https://www.santasnorthpole.com/games' 
  },
  {
    title: "Christmas Tree Light Up",
    description: "A fun puzzle game to connect the wires and light up the tree.",
    linkUrl: 'https://www.mathgametime.com/games/christmas-tree-light-up' 
  },
  {
    title: "Poki Christmas Games",
    description: "A large collection of Christmas-themed games.",
    linkUrl: 'https://poki.com/en/christmas' 
  },
  {
    title: "CBeebies Games",
    description: "Games, songs, and activities from the BBC.",
    linkUrl: 'https://www.bbc.co.uk/cbeebies/games' 
  },
  {
    title: "Make a Christmas Tree",
    description: "Decorate your very own tree with lights, ornaments, and more.",
    linkUrl: 'https://www.abcya.com/games/make_a_christmas_tree'
  },
  {
    title: "Poki Jigsaw Puzzles",
    description: "Put together fun and festive puzzles of all skill levels.",
    linkUrl: 'https://poki.com/en/jigsaw-puzzles'
  },
  {
    title: "Christmas Match 3",
    description: "A classic holiday-themed match-3 puzzle game.",
    linkUrl: 'https://www.safekidgames.com/christmas-games/christmas-match-3/'
  },
  {
    title: "North Pole Activities",
    description: "Read jokes, see top elf names, and send a virtual letter to Santa.",
    linkUrl: 'https://www.santasnorthpole.com/activities'
  },
];

function GamesPage() {
  
  useEffect(() => {
    document.title = "Free Christmas Games & Activities for Kids | Christmas Lights Map";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', "Play free online Christmas games for kids! Santa's Sleigh Dash, puzzles, coloring, and more. Safe fun for ages 3-12.");
    }
    return () => {
      document.title = "Christmas Lights Map 2025";
    };
  }, []);

  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": gameList.map((game, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": game.title,
      "url": game.linkUrl,
      "description": game.description
    }))
  };

  return (
    <Container maxWidth="lg">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListSchema) }} />

      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Christmas Games Arcade
        </Typography>
        <Typography variant="h6" align="center" color="textSecondary" paragraph>
          Fun and safe games for ages 3-12.
        </Typography>

        <Grid container spacing={4} sx={{ mt: 2 }}>
          {gameList.map((game) => (
            <Grid item key={game.title} xs={12} sm={6} md={4}>
              <Card 
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  transition: 'transform 0.2s',
                  '&:hover': { transform: 'scale(1.02)' } // Little hover effect
                }}
              >
                <CardContent sx={{ flexGrow: 1, textAlign: 'center' }}>
                  <Typography gutterBottom variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                    {game.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {game.description}
                  </Typography>
                </CardContent>

                {/* --- UNIFORM BUTTON SECTION --- */}
                <CardActions sx={{ p: 2 }}>
                  <Button 
                    component="a"
                    href={game.linkUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    variant="contained" 
                    color="success"
                    fullWidth 
                    size="large"
                    startIcon={<SportsEsportsIcon />}
                  >
                    Play Now
                  </Button>
                </CardActions>
                {/* ------------------------------ */}

              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
}

export default GamesPage;